<script lang="ts" setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import Typography from '@/components/common/Typography.vue'

const emit = defineEmits(['close'])
</script>

<template>
  <div>
    <CommonButton
      is-on-dark
      shape="icon"
      :aria-label="$t('settings.close')"
      @click="emit('close')"
    >
      <FontAwesomeIcon :icon="faXmark" />
    </CommonButton>
    <Typography
      variant="h2"
      component="h1"
      class="title"
    >
      {{ $t('settings.title') }}
    </Typography>
  </div>
</template>

<style lang="scss" scoped>
  div {
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;

    @include vgs-media-mobile {
      gap: 20px;
    }
  }

  button {
    align-self: flex-end;
  }

  .title {
    margin: 0;
  }
</style>
